export default __webpack_public_path__ + "static/epica-lite-9-91887e04bd37848858592e9d97b26706.jpg";